import React from "react";
import {
  Box,
  Typography,
  Stack,
  Link,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

// Desktop Footer
const FooterDesktop = () => (
  <>
    {/* Full-width Image above Footer */}
    <Box
      sx={{
        width: "100%",
        height: 280,
        position: "relative",
        backgroundImage: `url("homepage/footer.png")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: 120,
          transform: "translateY(-50%)",
          color: "#fff",
          textAlign: "left",
          width: "50%",
          zIndex: 2,
        }}
      >
        <Typography variant="h3" fontWeight="bold" gutterBottom>
          STAY IN TOUCH
        </Typography>
        <Typography variant="body1">
          Connect with us to stay informed about our latest services, upcoming events, and valuable resources.<br />
          Subscribe to receive updates, insights, and exclusive announcements tailored just for you.
        </Typography>
      </Box>
    </Box>

    <Box
      component="footer"
      sx={{
        backgroundColor: "#1a1a1a",
        color: "#fff",
        py: 6,
        px: 10,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: 10,
        }}
      >
        {/* Left Section */}
        <Box sx={{ flex: "1 1 30%", minWidth: 250, ml: "41px" }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <img
              src="/homepage/anagha.png"
              alt="Anagha Engineers"
              style={{ height: "55px" }}
            />
            <Typography variant="h4" sx={{ color: "#fff", fontWeight: "bold", ml: 1 }}>
              ANAGHA <br />ENGINEERS
            </Typography>
          </Box>
          <Typography
            variant="subtitle1"
            sx={{ fontStyle: "italic", color: "gray", mb: 2, fontSize: "1rem" }}
          >
            Let’s engineer a better future together.
          </Typography>
        </Box>

        {/* Middle Section — Explore */}
        <Box sx={{ flex: "1 1 20%", minWidth: 200, display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: "#fff", mb: 2, textTransform: "uppercase" }}>
            Explore
          </Typography>
          <Stack direction="column" spacing={1} alignItems="center">
            <Link href="#" underline="hover" color="inherit">Home</Link>
            <Link href="#" underline="hover" color="inherit">About Us</Link>
            <Link href="#" underline="hover" color="inherit">Services</Link>
            <Link href="#" underline="hover" color="inherit">Contact</Link>
          </Stack>
        </Box>

        {/* Right Section — Connect */}
        <Box sx={{ flex: "1 1 30%", minWidth: 250, display: "flex", flexDirection: "column", textAlign: "left", position: "relative", left: "170px" }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: "#fff", mb: 2, textTransform: "uppercase" }}>
            Connect
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
            <LocationOnIcon fontSize="small" sx={{ color: "gray" }} />
            <Typography variant="body2">Flat No:4-10/3 Nagaram Road,<br /> Hyderabad-500083, Telangana</Typography>
          </Stack>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
            <EmailIcon fontSize="small" sx={{ color: "gray" }} />
            <Typography variant="body2">admin@anaghaengineers.com</Typography>
          </Stack>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
            <PhoneIcon fontSize="small" sx={{ color: "gray" }} />
            <Typography variant="body2">+91 9505474849</Typography>
          </Stack>
          <Stack direction="row" spacing={2}>
            <Link href="#" color="inherit"><FacebookIcon /></Link>
            <Link href="#" color="inherit"><LinkedInIcon /></Link>
            <Link href="#" color="inherit"><InstagramIcon /></Link>
          </Stack>
        </Box>
      </Box>

      <Divider sx={{ backgroundColor: "gray", my: 4 }} />

      <Typography variant="body2" sx={{ color: "gray", textAlign: "center", mt: 2 }}>
        © 2025 Anagha Engineers. All Rights Reserved.
      </Typography>
    </Box>
  </>
);

// Mobile Footer
const FooterMobile = () => (
  <>
    {/* Full-width Image */}
    <Box
      sx={{
        width: "100%",
        height: 180,
        position: "relative",
        backgroundImage: `url("homepage/footer.png")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: 20,
          transform: "translateY(-50%)",
          color: "#fff",
          textAlign: "left",
          width: "90%",
          zIndex: 2,
        }}
      >
         <Typography variant="h4" fontWeight="bold" gutterBottom>
          STAY IN TOUCH
        </Typography>
        <Typography variant="body1">
          Connect with us to stay informed about our latest services, upcoming events, and valuable resources.<br />
          
        </Typography>
      </Box>
    </Box>

    <Box
      component="footer"
      sx={{
        backgroundColor: "#1a1a1a",
        color: "#fff",
        py: 6,
        px: 3,
      }}
    >
      {/* Left Section */}
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <img src="/homepage/anagha.png" alt="Anagha Engineers" style={{ height: "55px" }} />
          <Typography variant="h5" sx={{ color: "#fff", fontWeight: "bold", ml: 1 }}>
            ANAGHA <br />ENGINEERS
          </Typography>
        </Box>
        <Typography variant="subtitle1" sx={{ fontStyle: "italic", color: "gray", mb: 2 }}>
          Let’s engineer a better future together.
        </Typography>
      </Box>

      <Divider sx={{ backgroundColor: "gray", mb: 3 }} />

      {/* Connect Section */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: "#fff", mb: 2, textTransform: "uppercase" }}>
          Connect
        </Typography>
        <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ mb: 1 }}>
          <LocationOnIcon fontSize="small" sx={{ color: "gray", mt: "3px" }} />
          <Typography variant="body2">
            Flat No:4-10/3 Nagaram Road,<br /> Hyderabad-500083, Telangana
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
          <EmailIcon fontSize="small" sx={{ color: "gray" }} />
          <Typography variant="body2">admin@anaghaengineers.com</Typography>
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
          <PhoneIcon fontSize="small" sx={{ color: "gray" }} />
          <Typography variant="body2">+91 9505474849</Typography>
        </Stack>
        <Stack direction="row" spacing={2}>
          <Link href="#" color="inherit"><FacebookIcon /></Link>
          <Link href="#" color="inherit"><LinkedInIcon /></Link>
          <Link href="#" color="inherit"><InstagramIcon /></Link>
        </Stack>
      </Box>

      <Divider sx={{ backgroundColor: "gray", mb: 3 }} />

      {/* Explore Section */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: "#fff", mb: 2, textTransform: "uppercase" }}>
          Explore
        </Typography>
        <Stack direction="column" spacing={1} alignItems="flex-start">
          <Link href="#" underline="hover" color="inherit">Home</Link>
          <Link href="#" underline="hover" color="inherit">About Us</Link>
          <Link href="#" underline="hover" color="inherit">Services</Link>
          <Link href="#" underline="hover" color="inherit">Contact</Link>
        </Stack>
      </Box>

      <Divider sx={{ backgroundColor: "gray", my: 4 }} />

      <Typography variant="body2" sx={{ color: "gray", textAlign: "center", mt: 2 }}>
        © 2025 Anagha Engineers. All Rights Reserved.
      </Typography>
    </Box>
  </>
);

// Main Footer Component
export default function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return isMobile ? <FooterMobile /> : <FooterDesktop />;
}
